/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { Status, Loading, ajax, getState, getConfig, evalJson, getBrand, } from '../twd'


const Last = getState('bond_detail.last', {ts:0, cusip:''})

export const Context = React.createContext()
export const ContextProvider = ({cusip:cusip_, children}) => {

    cusip_ = cusip_ || Last.value.cusip
    const [cusip, setCusip] = React.useState(cusip_ || Last.value.cusip)
    const [issue, setIssue] = React.useState({})
    const [hold, setHold] = React.useState([])
    const [bid, setBid] = React.useState({})
    const [offer, setOffer] = React.useState({})
    const [ask, setAsk] = React.useState({})
    const [desc, setDesc] = React.useState({})
    const [events, setEvents] = React.useState([])
    const [status, setStatus] = React.useState(Status.LOADING)

    React.useEffect(() => {

        setCusip(cusip_)
        Last.set({cusip})
        setHold(getConfig('cusips_held', {})[cusip_] || [])

        ;(async () => {

            try {
                setStatus(Status.LOADING)

                let {data:issuedata} = await ajax({
                    url:'/esb/portfolio/cusip/issuedata',
                    method: 'GET',
                    params: { cusip: cusip_ }
                })
                let data_ = (await issuedata).IssueData || {}
                if (Object.keys(data_).length===0) {
                    setStatus('Not Found')
                    return
                }

                let {data:bookdata} = await ajax({
                    url:'/esb/portfolio/cusip/warningAndBook',
                    method: 'POST',
                    params: {
                        "p_criteria_fmt":"ADVANCED",
                        "p_cusip": cusip_,
                        "p_maxrows":1,
                        "p_monarch":"Y",
                        "p_output_fmt":"JSON",
                        "p_multiple":["BOL-UOR","BOL-ROR"],
                        "p_submit":"JSON",
                        "p_redirect_output":"Y",
                        "p_type":"0",
                        "p_min_qty":1,
                        "p_is_offer_search":false,
                        "p_search_criteria":{},
                        "p_mode":"RP"
                    }
                })
                let warn_ = (await bookdata)[0] || {}

                let {data:descdata} = await ajax({
                    url:'/esb/retailservice/bondDetailService/getIssueDesc',
                    method: 'POST',
                    params: ({
                        p_cusip: cusip_,
                        p_id_type: 'I',
                        p_brand: getBrand(),
                        p_alloc_id: '',
                        p_watch_id: '',
                        p_ngw: 'Y',
                    })
                })
                let desc_ = evalJson(await descdata, {})
                setDesc(desc_ || {})
                let issue_ = Object.assign(desc_.issue || {},
                    {
                        data: data_,
                        issueDisplay: data_.issueDisplay,
                        warningText: data_.warningTextRewrite,
                        babInd: data_.babInd,
                        spInd: data_.spInd,
                        condCallableInd: data_.condCallableInd,
                        research: data_.research,
                        allowTrading: warn_.allowTrading,
                        showBook: warn_.showBook,
                    })
                setIssue(issue_)
                let offer_ = desc_.bestoffer || {}
                setOffer(offer_)
                setAsk(offer_.ask || {})
                setBid(offer_.bid || {})



                let {data:eventsdata} = await ajax({
                    url:'/esb/retailservice/bondDetailService/getSecurityEvents ',
                    method: 'POST',
                    params: ({
                        cusip: cusip_,
                        invType: issue_.type,
                    })
                })
                let events_ = evalJson(await eventsdata, {}).securityeventsjson
                setEvents(events_ || [])

                setStatus(Status.LOADED)
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()
    }, [cusip_ || Last.value.params])


    return <Context.Provider
        value={{
            cusip,
            issue,
            offer,
            bid,
            ask,
            hold,
            events,
            desc,
            status,
        }}>
        <Loading status={status}>
        {children}
        </Loading>
    </Context.Provider>
}
export const useBondDetail = () => React.useContext(Context)

export const hasCreditRatings = (issue) => {

    if (issue.type==='T' && issue.category==='B') {
        return true
    }
    return ['S', 'R', 'O', 'L'].indexOf(issue.type) < 0
}